@if (swiper) {
<div class="carousel-dots"
     [class.ng-hide]="(bullets && bullets.length || 0) <= 1"
     [style.--carousel-dots-number]="bullets.length">
    <div class="carousel-dots-inner"
         aria-label="Carousel Pagination">
        @for (bullet of $any(bullets); track $index; let i = $index) {
        <button class="carousel-dot"
                [class.is-active]="index === i"
                type="button"
                [attr.aria-label]="'Carousel Page ' + (i + 1) + (index === i ? ' (Current Slide)' : '')"
                (click)="slideTo(i)"></button>
        }
        <div class="carousel-dots-underbar"></div>
    </div>
</div>
}

<!-- hide swiper pagination -->
<div class="ng-hide"
     [ngClass]="paginationClass || ''"></div>